import { useDispatch, useSelector } from "react-redux";
import { cartActions } from "../../storage/cart";
import api from "../../storage/api";
import { useContext, useEffect, useState } from "react";
import { modalActions } from "../../storage/modals";
import { useNavigate } from "react-router-dom";
import { Flex, Popconfirm, Typography } from "antd";
import { AppContext } from "../../pages/Root";

const Cart = (props) => {
  const cart = useSelector((state) => state.cart);
  const [totals, setTotals] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [nick, setNick] = useState("");
  const [email, setEmail] = useState("");
  const [nickError, setNickError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [searchTerm, setSearchTerm] = useState(cart.promocode);
  const [paymentSystem, setPaymentSystem] = useState("");
  const [tipsReciever, setTipsReciever] = useState("");
  const { serverLogo, serverSlug } = useContext(AppContext);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      dispatch(cartActions.setPromocode(searchTerm));
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm, dispatch]);

  const removeItemHandler = (id, name) => {
    const confirm = window.confirm(`Вы действительно желаете удалить "${name}" из корзины?`);

    if (confirm) {
      dispatch(cartActions.removeFromCart(id));
    }
  };

  const setTips = (amount) => {
    dispatch(cartActions.setTips(amount));
  };

  useEffect(() => {
    const syncCart = async () => {
      setIsLoading(true);
      const response = await fetch(`${api.apiPath}&path=cart`, {
        method: "POST",
        body: JSON.stringify({
          method: "cartValidation",
          payload: cart,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        console.log("error while loading the cart");
        return;
      }

      const data = await response.json();
      setIsLoading(false);
      setTotals(data);
      if (data.goods.length < cart.goods.length) {
        const replaceCart = {
          totalAmount: data.total + ".00",
          goods: data.goods,
          promocode: data.promocode ? data.promocode.code : "",
        };
        dispatch(cartActions.setCart(replaceCart));
      }

      if (data.tips && Array.isArray(data.tips.admins) && data.tips.admins[0]?.id) {
        setTipsReciever(data.tips.admins[0].id);
      }

      setPaymentSystem(data.payments[0].code);
    };

    if (cart.goods.length > 0) {
      syncCart();
    }
  }, [cart, dispatch]);

  const openAgreementPage = (e) => {
    e.preventDefault();
    dispatch(modalActions.hideAllModals());
    navigate("/agreement");
    return false;
  };

  const submitOrder = () => {
    if (nick.trim() === "") {
      setNickError(true);
      return;
    }

    setIsSubmitting(true);

    const submitAjax = async () => {
      const response = await fetch(`${api.apiPath}&path=cart`, {
        method: "POST",
        body: JSON.stringify({
          method: "submitOrder",
          payload: {
            cart,
            nick,
            email,
            paymentSystem,
            tipsReciever,
          },
        }),
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        window.alert("Не удалось сохранить заказ... Поробуйте позже.");
        return;
      }

      const data = await response.json();

      if (data.error) {
        window.alert(data.error);
        setIsSubmitting(false);
        return;
      }

      if (data.voting) {
        dispatch(modalActions.hideAllModals());
        dispatch(modalActions.showCartVoting(data));
        setIsSubmitting(false);
      } else {
        localStorage.removeItem("cart");

        if (data.paylink) {
          window.location.href = data.paylink;
        } else {
          window.alert("Ошибка при формировании платежной ссылки. Попробуйте позже или обратитесь к администратору");
        }

        return null;
      }
    };

    submitAjax();
  };

  const isTips = !!totals.tips && totals.tips && Array.isArray(totals.tips.admins) && totals.tips.admins.length > 0;

  return (
    <div className="modal-window modal-window_checkout">
      <div className="modal-controls-wrapper">
        <h5 className="modal-title">Оформление заказа</h5>
        <button type="button" className="modal-close" onClick={props.closeHandler}></button>
      </div>
      {cart.goods.length === 0 ? (
        <p>Корзина пуста</p>
      ) : (
        <div className="modal-checkout">
          <div className="modal-checkout__goods">
            {cart.goods.map((item) => (
              <div className="modal-checkout-item" key={item.id}>
                <button
                  type="button"
                  className="modal-checkout-item__remove"
                  onClick={() => {
                    removeItemHandler(item.id, item.name);
                  }}
                ></button>
                <div className="modal-checkout-item__body">
                  <div className="modal-checkout-item-img">
                    {item.id === "money" && <img src={item.icon} alt={item.name} />}
                    {item.id !== "money" && <img src={item.icon !== "" ? api.apiUrl + item.icon : "/assets/images/dummy_product.png"} alt={item.name} />}
                  </div>
                  <div className="modal-checkout-item-data">
                    <div className="modal-checkout-item-meta">
                      <div className="modal-checkout-item-title-row">
                        <h5 className="modal-checkout-item-title">{item.name}</h5>
                        {item.category && <span className="modal-checkout-item-category">{item.category}</span>}
                      </div>
                      <span className="modal-checkout-item-price">{item.total} ₽</span>
                    </div>
                    <span className="modal-checkout-item-period">{item.period}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="modal-checkout__summary">
            {isLoading && (
              <div className="modal-checkout-totals modal-checkout-totals_loading">
                <div className="modal-checkout-totals-wrapper">
                  <div className="modal-checkout-total-row"></div>
                  <div className="modal-checkout-total-row"></div>
                </div>
                <div className="modal-checkout-total-summary"></div>
              </div>
            )}
            {!isLoading && (
              <div className="modal-checkout-totals">
                <div className="modal-checkout-totals-wrapper">
                  <div className="modal-checkout-total-row">
                    <span className="modal-checkout-total-row__title">Сумма заказа:</span>
                    <span className="modal-checkout-total-row__value">{totals.total} ₽</span>
                  </div>
                  {totals.promocode && !totals.promocode.error && (
                    <div className="modal-checkout-total-row">
                      <span className="modal-checkout-total-row__title">Промокод ({totals.promocode.code}):</span>
                      <span className="modal-checkout-total-row__value">-{totals.promocode.discount} ₽</span>
                    </div>
                  )}
                  {totals.tips.amount > 0 && (
                    <div className="modal-checkout-total-row">
                      <span className="modal-checkout-total-row__title">Чаевые:</span>
                      <span className="modal-checkout-total-row__value">{totals.tips.amount} ₽</span>
                    </div>
                  )}
                </div>
                <div className="modal-checkout-totals-summary-wrapper">
                  {totals.overall > 0 && (
                    <div className="modal-checkout-total-row">
                      <span className="modal-checkout-total-row__title">Итого:</span>
                      <span className="modal-checkout-total-row__value">{totals.overall} ₽</span>
                    </div>
                  )}
                  {totals.fee > 0 && (
                    <div className="modal-checkout-total-row">
                      <span className="modal-checkout-total-row__title">Комиссия системы:</span>
                      <span className="modal-checkout-total-row__value">{totals.fee} ₽</span>
                    </div>
                  )}
                  <div className="modal-checkout-total-summary">
                    <span className="modal-checkout-total-summary__title">К оплате:</span>
                    <span className="modal-checkout-total-summary__value">{totals.toPay} ₽</span>
                  </div>
                </div>
              </div>
            )}
            {!isLoading && (
              <div className="modal-checkout-form">
                <div className="modal-checkout-fields">
                  <div className="modal-checkout-input-block">
                    <span className="modal-checkout-input-block__title">Введите ваш ник</span>
                    <input
                      type="text"
                      className="modal-checkout-input-block__input"
                      placeholder="Никнейм"
                      value={nick}
                      onInput={(e) => {
                        setNick(e.target.value.trim());
                        setNickError(false);
                      }}
                    />
                    {nickError && (
                      <div
                        className="modal-checkout-total-row"
                        style={{
                          marginTop: "10px",
                          color: "#dd4443",
                          fontSize: "12px",
                        }}
                      >
                        <span className="modal-checkout-total-row__title">Введите ваш ник</span>
                      </div>
                    )}
                  </div>
                  <div className="modal-checkout-input-block">
                    <span className="modal-checkout-input-block__title">Введите ваш email</span>
                    <input
                      type="email"
                      className="modal-checkout-input-block__input"
                      placeholder="Email для чека"
                      value={email}
                      onInput={(e) => {
                        setEmail(e.target.value.trim());
                      }}
                    />
                  </div>
                  <div className="modal-checkout-input-block">
                    <span className="modal-checkout-input-block__title">Промокод (если есть)</span>
                    <input type="text" className="modal-checkout-input-block__input" placeholder="ХХХХХХХ" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                    {totals.promocode.error && (
                      <div
                        className="modal-checkout-total-row"
                        style={{
                          marginTop: "10px",
                          color: "#dd4443",
                          fontSize: "12px",
                        }}
                      >
                        <span className="modal-checkout-total-row__title">{totals.promocode.error}</span>
                      </div>
                    )}
                  </div>
                  {isTips && (
                    <div className="modal-checkout-input-block">
                      <span className="modal-checkout-input-block__title">Чаевые</span>
                      <div className="tips-wrapper-selector">
                        <button className={cart.tips === 0 ? "tips-selector-btn selected" : "tips-selector-btn"} onClick={() => setTips(0)}>
                          0%
                        </button>
                        <button className={cart.tips === 5 ? "tips-selector-btn selected" : "tips-selector-btn"} onClick={() => setTips(5)}>
                          5%
                        </button>
                        <button className={cart.tips === 10 ? "tips-selector-btn selected" : "tips-selector-btn"} onClick={() => setTips(10)}>
                          10%
                        </button>
                        <button className={cart.tips === 15 ? "tips-selector-btn selected" : "tips-selector-btn"} onClick={() => setTips(15)}>
                          15%
                        </button>
                      </div>
                    </div>
                  )}
                  {isTips && (
                    <div className="modal-checkout-input-block">
                      <span className="modal-checkout-input-block__title">Кому отправить на чай?</span>
                      <div className="modal-checkout-input-block__select">
                        <select
                          className="modal-checkout-input-block-select"
                          value={tipsReciever}
                          onChange={(e) => {
                            setTipsReciever(e.target.value);
                          }}
                          disabled={isSubmitting ? true : false}
                        >
                          {totals.tips.admins.map((item) => (
                            <option value={item.id} key={item.id}>
                              {item.nickname}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  )}
                </div>
                <div className="modal-checkout-bottom">
                  <div className="modal-checkout-input-block">
                    <span className="modal-checkout-input-block__title">Метод оплаты</span>
                    <div className="modal-checkout-input-block__select">
                      <select
                        className="modal-checkout-input-block-select"
                        value={paymentSystem}
                        onChange={(e) => {
                          setPaymentSystem(e.target.value);
                        }}
                        disabled={isSubmitting ? true : false}
                      >
                        {totals.payments.length > 0 &&
                          totals.payments.map((item) => (
                            <option value={item.code} key={item.code}>
                              {item.title}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <Popconfirm
                    title="Подтвердите сервер на котором будет произведена оплата"
                    description={
                      <Flex vertical align="center" gap={"small"}>
                        <Typography.Text>
                          Вы собираетесь оплатить заказ на сервере:{" "}
                          <Typography.Text type="warning" style={{ fontWeight: "bold" }}>
                            {serverSlug.toUpperCase()}
                          </Typography.Text>
                        </Typography.Text>
                        {serverLogo && <img src={`${api.apiImages}${serverLogo}`} alt="Server logo" style={{ width: 96, height: 32 }} />}
                      </Flex>
                    }
                    onConfirm={submitOrder}
                    onCancel={() => {}}
                    okText="Продолжить"
                    cancelText="Отмена"
                  >
                    <button type="button" className="modal-btn modal-btn_checkout" disabled={isSubmitting ? true : false}>
                      Оплатить заказ за {totals.toPay} ₽
                    </button>
                  </Popconfirm>
                  <p className="modal-checkout-alert">
                    Нажимая на кнопку оплаты, вы в полном объеме принимаете{" "}
                    <a href="/agreement" className="modal-checkout-alert__link" onClick={openAgreementPage}>
                      пользовательское соглашение
                    </a>
                    .<br />
                    Денежные средства возврату не подлежат.
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Cart;
